import React, { useState } from 'react'
import { CardBody, Col, Row, TabPane, CardHeader, Input } from "reactstrap";
// import { FilePond } from "react-filepond";
import "filepond/dist/filepond.min.css";
import Toast from '../../../../../Components/Common/Toast';
import { downloadFile } from '../../../../../Components/Common/fileDownloadUtil';
import { ToastContainer } from 'react-toastify';

const ImportCsv = ({ toggleArrowTab, activeArrowTab, setCsvHeaders, setFiles, files }) => {
  const [isDragging, setIsDragging] = useState(false);

  // Validate CSV headers
  const validateCSVHeaders = (fileContent) => {
    try {
      // Get the first line of the CSV file to extract headers
      const firstLine = fileContent.split("\n")[0];
      const headers = firstLine.split(",").map((header) => header.trim());

      // Set headers to state for further use (optional)
      setCsvHeaders(headers);

      // Return true if headers are valid (modify as needed)
      return true;
    } catch (error) {
      Toast("Error validating CSV headers", "error");
      return false;
    }
  };

  // Before adding a file, validate the file
  const beforeAddFile = (file) => {
    return new Promise((resolve) => {
      const allowedExtension = "csv";
      const fileExtension = file.file.name.split(".").pop().toLowerCase();

      // Check if file has correct extension
      if (fileExtension !== allowedExtension) {
        Toast("Please upload only CSV files", "error");
        resolve(false);
        return;
      }

      // Check if the file type is correct (MIME type)
      if (file.file.type !== "text/csv") {
        Toast("Invalid file type. Only CSV files are allowed.", "error");
        resolve(false);
        return;
      }

      // Check if the file size exceeds the 5MB limit
      const maxSize = 5 * 1024 * 1024;
      if (file.file.size > maxSize) {
        Toast("File size exceeds 5MB limit", "error");
        resolve(false);
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        const content = event.target.result;

        // Check if file content is empty
        if (!content.trim()) {
          Toast("CSV file is empty", "error");
          resolve(false);
          return;
        }

        // Validate CSV headers
        const isValid = validateCSVHeaders(content);
        resolve(isValid);
      };

      reader.onerror = () => {
        Toast("Error reading file", "error");
        resolve(false);
      };

      // Read file content as text
      reader.readAsText(file.file);
    });
  };

  // Handle file add (successful file upload)
  const onAddFile = (error, file) => {
    if (error) {
      alert(error.message);
      return;
    }
    setFiles(file);
    toggleArrowTab(activeArrowTab + 1);

  };

  // Example usage
  const downloadSampleExcelFile = () => {
    downloadFile({
      filePath: '/ExcelFile/lead_bulk_import.csv',
      fileName: 'Sample_Bulk_File.csv',
      onSuccess: () => {
        Toast("Sample Bulk file downloaded successfully", "success");
      },
      onError: (error) => {
        Toast(error.message || "Error downloading sample file", "error");
        console.error(error);
      }
    });
  };

  const handleFile = (file) => {
    if (file) {
      beforeAddFile({ file }).then((isValid) => {
        if (isValid) {
          onAddFile(null, file);
        }
      });
    }
  };

  return (
    <>
      <ToastContainer />
      <TabPane id="steparrow-gen-info" tabId={4}>
        <div className="sn-tabs-body-txt">
          <Row className="mt-2">
            <Col lg={12}>
              <Row>
                <CardHeader>
                  Download Sample{" "}
                  <button
                    type="button"
                    className="btn btn-icon text-muted btn-sm fs-18"
                    title="Sample import"
                    onClick={downloadSampleExcelFile}
                  >
                    <i className="ri-download-2-line"></i>
                  </button>
                </CardHeader>
                <CardBody>
                  <p className="text-muted mt-4">
                    Please ensure that the uploaded CSV file matches the format provided in the
                    sample file for successful processing.
                  </p>

                  {/* <div className="file-upload-container">
                    <label htmlFor="file-upload" className="file-upload-label">
                      <div className="file-upload-content">
                        {files ? (
                          <span className="selected-file">Selected: {files.name}</span>
                        ) : (
                          <>
                            Drag & Drop your files or <span className="browse-text">Browse</span>
                          </>
                        )}
                      </div>
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      className="file-upload-input"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          setFiles(file);
                          beforeAddFile({ file }).then((isValid) => {
                            if (isValid) {
                              onAddFile(null, file);
                            }
                          });
                        }
                      }}
                      multiple
                    />
                  </div> */}


                  <div
                    className="file-upload-container"
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setIsDragging(true);
                    }}
                    onDragLeave={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setIsDragging(false);
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setIsDragging(false);
                      const files = Array.from(e.dataTransfer.files);
                      if (files.length) {
                        handleFile(files[0]);
                      }
                    }}
                  >
                    <label
                      htmlFor="file-upload"
                      className={`file-upload-label ${isDragging ? 'dragging' : ''}`}
                    >
                      <div className="file-upload-content">
                        Drag & Drop your files or <span className="browse-text">Browse</span>
                      </div>
                      <span className="selected-file">{files.name}</span>

                      <input
                        id="file-upload"
                        type="file"
                        className="file-upload-input"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          handleFile(file);
                        }}
                        multiple
                      /> </label>
                  </div>
                </CardBody>
              </Row>
            </Col>
          </Row>
        </div>
        {/* <div className="d-flex align-items-start gap-3 mt-4 sn-bulk-import-information-button">
          <button
            type="button"
            className={`btn btn-danger btn-label right ms-auto nexttab nexttab mt-4 ${!files?.name ? 'disabled' : ''}`}
            disabled={!files?.name}
            onClick={() => {
              toggleArrowTab(activeArrowTab + 1);
            }}
          >
            <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
            Next
          </button>
        </div> */}

      </TabPane>
    </>
  )
}

export default ImportCsv
